import WorkOutlineIcon from '@material-ui/icons/WorkOutline'
import React from 'react'
import './ProjectButton.css'
import { Zoom } from 'react-reveal'

function ProjectButton() {
    return (
        <div className='projectButton'>
            <Zoom top>
                <WorkOutlineIcon className='projectIcon' />
            </Zoom>        
        </div>
    )
}

export default ProjectButton
